// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2947":"4d181e1bce10ada4","3578":"425efebfc692f61f","3874":"57304697c8680115"}[chunkId] + ".css";
};